import React from 'react';
import { useTranslation } from '@shared/core';
import { Flex, FlexProps, TextV2 } from '@withjoy/joykit';
import { useHistory } from '@react-router';
import { ProgressRing } from '../ProgressRing';
import { StyledButton, StyledPriceRangeWrapper, StyledTextWrapper, styles } from './styles';
import { useRoutePaths } from '@apps/registry/admin/Registry.routes';
import qs from 'query-string';
import { Page, useRegistryGiftCountsTelemetry } from '../../telemetry';
import { useRegistryOverviewTelemetry } from '@apps/registry/admin/routes/Overview/telemetry';
import { useCatalogContext } from '../../../Catalog';

interface PriceRangeProps extends FlexProps {
  title: string;
  targetGiftCount: number;
  completedGiftCount: number;
  isOpen: boolean;
  priceRangeQuery: string;
  page: Page;
  closeDrawer?: () => void;
}

export const PriceRange = ({ title, targetGiftCount, completedGiftCount, isOpen, priceRangeQuery, closeDrawer, page, ...props }: PriceRangeProps) => {
  const history = useHistory();
  const paths = useRoutePaths();
  const { cheatSheetPricePointClicked } = useRegistryGiftCountsTelemetry();

  const telemetry = useRegistryOverviewTelemetry();
  const { t } = useTranslation('sharedComponents');
  const { giftCounts, button } = t('registryGiftCounts');
  const { removeSelectedCategory } = useCatalogContext();

  const handleOnClickShopPriceRange = () => {
    telemetry.registryOverviewInteraction({ component: 'Gift Count / Price Point Guide', method: 'CheatSheetPricePointClicked', label: title });
    cheatSheetPricePointClicked(title, page);
    const priceCustom = {
      pf: `priceRange=${priceRangeQuery}`,
      showFilters: true
    };
    removeSelectedCategory();
    history.push({ pathname: `${paths.catalog.path}/recommended`, search: qs.stringify(priceCustom) });

    closeDrawer?.();
  };

  return (
    <StyledPriceRangeWrapper __css={styles.priceRangeWrapper} {...props}>
      <ProgressRing isOpen={isOpen} currentGiftCount={completedGiftCount} progressPercent={(completedGiftCount / targetGiftCount) * 100} />
      <StyledTextWrapper __css={styles.textWrapper}>
        <Flex alignItems="center">
          <TextV2 typographyVariant="hed1" whiteSpace="nowrap" marginRight={2}>
            {title}
          </TextV2>
        </Flex>
        {targetGiftCount !== 0 && (
          <TextV2 typographyVariant="label2" whiteSpace="nowrap" color="mono10">
            {giftCounts({ targetCount: targetGiftCount })}
          </TextV2>
        )}
        <StyledButton {...styles.button} onClick={handleOnClickShopPriceRange}>
          {button()}
        </StyledButton>
      </StyledTextWrapper>
    </StyledPriceRangeWrapper>
  );
};
